const months: string[] = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

function parseDateString(dateString: string): Date {
  const arr = dateString.split(/\D/);
  return new Date(+arr[0], +arr[1] - 1, +arr[2], +arr[3], +arr[4], +arr[5]);
}

export const serverDateToLocal = (dateString: string): string => {
  const parsedDate: Date = new Date(parseDateString(dateString));
  const day = parsedDate.getDay();
  const month = months[parsedDate.getMonth()];
  const year = parsedDate.getFullYear();
  return `${day} de ${month} de ${year}`;
};

export default serverDateToLocal;
